module.exports = __webpack_public_path__ + "img/reisen udongein inaba eternal.014b4a03.png";